export {
    type CategoriesCardTemplateProps,
    default,
} from './CategoriesCardTemplate';
